import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export default function Breadcrumbs({ items = [] }) {
  const all = [{ label: "Home", to: "/" }, ...items];
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: all.map((it, i) => ({
      "@type": "ListItem", position: i + 1, name: it.label,
      item: `https://chouhantaxiservice.com${it.to || ""}`,
    })),
  };
  return (
    <nav className="container-x pt-5 text-sm" aria-label="Breadcrumb" data-testid="breadcrumbs">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
      <ol className="flex items-center flex-wrap gap-1 text-slate-500">
        {all.map((it, i) => (
          <li key={i} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="w-3.5 h-3.5" />}
            {it.to && i < all.length - 1 ? (
              <Link to={it.to} className="hover:text-brand">{it.label}</Link>
            ) : (
              <span className="text-navy-heading font-medium">{it.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
